import { createFileRoute, redirect } from '@tanstack/react-router';

/** Indirizzo vecchio di una notifica: ora si apre sopra l'elenco. */
export const Route = createFileRoute('/_app/notifications/$notificationId')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/notifications', search: { open: params.notificationId } });
  },
});
